import { AutocompleteZoomPopper } from 'src/utils/autocompleteZoom';

// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      defaultProps: {
        PopperComponent: AutocompleteZoomPopper
      },
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20
        },
        listbox: {
          boxSizing: 'border-box'
        },
        popper: {
          zIndex: theme.zIndex.modal
        }
      }
    }
  };
}
